document.addEventListener("DOMContentLoaded", function() {
  facetSetup();
});

function facetSetup() {
  var checkboxFacets = document.querySelectorAll('.filter-item a.filter-item__content');
  if(checkboxFacets){
    checkboxFacets.forEach((checkbox) => {
      checkbox.addEventListener('click', clickAction);
    });
  }

  var appliedFacets = document.querySelectorAll('[data-pill="facet"]');
  if(appliedFacets){
    appliedFacets.forEach((appliedFacet) => {
      appliedFacet.addEventListener('click', clickAction);
    });
  }

  var priceRangeInputs = document.querySelectorAll('.filter-item__price-input');
  if(priceRangeInputs){
    priceRangeInputs.forEach((priceRangeInput) => {
        priceRangeInput.addEventListener('input', debounce(inputAction, 650));
    });
  }

  var filterFlyoutTriggers = document.querySelectorAll('[data-filter-flyout-trigger]');
  if(filterFlyoutTriggers){
    filterFlyoutTriggers.forEach((filterFlyoutTrigger) => {
      filterFlyoutTrigger.addEventListener('click', mobileFilterFlyoutOpen);
    });
  }

  var filterFlyoutTriggersAlt = document.querySelectorAll('[data-filter-flyout-close]');
  if(filterFlyoutTriggersAlt){
    filterFlyoutTriggersAlt.forEach((filterFlyoutTriggerAlt) => {
      filterFlyoutTriggerAlt.addEventListener('click', mobileFilterFlyoutClose);
    });
  }
}

function clickAction(e){
  e.preventDefault();
  var filter_url = e.target.getAttribute('href');
  if(e.target.classList.contains('filter-item__content')){
    e.target.closest('.filter-item').classList.toggle('active');
  }
  runFilters(filter_url);
};

function inputAction(e){
  var filter_name = e.target.getAttribute('name');
  var filter_value = e.target.value;

  var current_filter_url = document.querySelector('[name=current_filter_url]').value;
  var filter_url = current_filter_url;

  if(current_filter_url.indexOf(filter_name) >= 0){
    var filter_old_values = new URLSearchParams(current_filter_url);
    var filter_old_value = filter_old_values.get(`${filter_name}`);
    filter_url = filter_url.replace(`${filter_name}=${filter_old_value}`, `${filter_name}=${filter_value}`);
  }
  else{
    if(current_filter_url.indexOf('?') >= 0){
      filter_url = filter_url +  `&${filter_name}=${filter_value}`;
    }
    else{
      filter_url = filter_url +  `?${filter_name}=${filter_value}`;
    }
  }

  runFilters(filter_url);
};

function runFilters(filter_url){
    var elem = document.querySelector("section.collection");
    if(elem == null) {elem = document.querySelector(".search-template");}
    var loading = elem.querySelector('.collection__loading');
    loading.classList.add('is-active');
    var sidebar = elem.querySelector('.collection__sidebar');
    var drawer = document.querySelector('[data-filter-flyout].active');
    if(drawer){
      document.body.style.paddingRight = document.body.dataset.origPaddingRight;
      document.body.style.overflow = document.body.dataset.origOverflow;
      delete document.body.dataset.origPaddingRight;
      delete document.body.dataset.origOverflow;
      document.querySelector('[data-filter-flyout].active').classList.remove('active');
      document.removeEventListener('click', mobileFilterFlyoutCloseAlt);
    }
    else{
      sidebar.classList.add('loading');
    }

    fetch(filter_url, {
      credentials: 'include'
    }).then(function (res) {
      return res.text();
    }).then(function (res) {
      window.history.pushState({}, '', filter_url);

      var doc = new window.DOMParser().parseFromString(res, 'text/html');
      contents_section = doc.querySelector('section.collection');
      if(contents_section == null) {contents_section = doc.querySelector(".search-template");}
      elem.innerHTML = contents_section.innerHTML

      facetSetup();
      //filtering;
      loading.classList.remove('is-active');
    });
}

function debounce(func, timeout = 300){
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

function mobileFilterFlyoutOpen(e){
  e.preventDefault();
  var filter = e.currentTarget.dataset.filterFlyoutTrigger;
  if(!document.querySelector('[data-filter-flyout].active') && document.querySelector('[data-filter-flyout="' + filter + '"]') && !document.querySelector('[data-filter-flyout="' + filter + '"]').classList.contains('active')){
    document.body.dataset.origPaddingRight = (document.body.style.paddingRight) ? document.body.style.paddingRight : '0px';
    document.body.dataset.origOverflow =  (document.body.style.overflow) ? document.body.style.overflow : 'visible';
    var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
    if (scrollBarGap > 0) {
      previousBodyPaddingRight = document.body.style.paddingRight;
      document.body.style.paddingRight = scrollBarGap + 'px';
    }
    else{
      document.body.style.paddingRight = document.body.dataset.origPaddingRight;
    }

    document.body.style.overflow = 'hidden';

    document.querySelector('[data-filter-flyout="' + filter + '"]').classList.add('active');

    e.stopPropagation();
    document.addEventListener('click', mobileFilterFlyoutCloseAlt);
  }
}

function mobileFilterFlyoutClose(e){
  e.preventDefault();
  var filter = e.currentTarget.dataset.filterFlyoutClose;

  if(document.querySelector('[data-filter-flyout="' + filter + '"]') && document.querySelector('[data-filter-flyout="' + filter + '"]').classList.contains('active')){
    document.body.style.paddingRight = document.body.dataset.origPaddingRight;
    document.body.style.overflow = document.body.dataset.origOverflow;
    delete document.body.dataset.origPaddingRight;
    delete document.body.dataset.origOverflow;
    document.querySelector('[data-filter-flyout="' + filter + '"]').classList.remove('active');

    document.removeEventListener('click', mobileFilterFlyoutCloseAlt);
  }
}

function mobileFilterFlyoutCloseAlt(e){
  if(!e.target.closest('.collection-flyout.drawer')){
    e.preventDefault();
    e.stopPropagation();
    if(document.querySelector('[data-filter-flyout].active')){
      document.body.style.paddingRight = document.body.dataset.origPaddingRight;
      document.body.style.overflow = document.body.dataset.origOverflow;
      delete document.body.dataset.origPaddingRight;
      delete document.body.dataset.origOverflow;
      document.querySelector('[data-filter-flyout].active').classList.remove('active');
      document.removeEventListener('click', mobileFilterFlyoutCloseAlt);
    }
  }
}